import { render, staticRenderFns } from "./Findpass.vue?vue&type=template&id=60233776&"
import script from "./Findpass.vue?vue&type=script&lang=js&"
export * from "./Findpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports